<template>
    <div>
      
               <div class="form-row position-relative">
           
            <div class="position-absolute text-right d-block more-options-menu" v-on:mouseover="hover=true"   v-on:mouseleave="hover = false" v-if="!readonly && (!first || last)">
                <ul class="list-inline p-1">
                    <li class="list-inline-item text-center" v-if="hover && last">
                        <a v-on:click="add" title="Aggiungi nuovo numero di fax" >
                            <font-awesome-icon icon="plus"></font-awesome-icon>
                        </a>
                    </li>
                    <li class="list-inline-item text-center"  v-if="hover && !first">
                        <a v-on:click="remove" title="Rimuovi numero di fax" class="text-danger">
                            <font-awesome-icon icon="times"></font-awesome-icon>
                        </a>
                    </li>
                    <li class="list-inline-item text-center"  v-if="!hover">
                        <a  class="text-mute">
                            <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                        </a>
                    </li>

                </ul>
            </div>
            <label class="col-12 col-form-label d-relative" :for="value.faxId">
                 <editable-label :label="value.label" @update-label="upddateLabel" :index="index" defaultLabel="Numero di fax"  :readonly="readonly"></editable-label>
            </label>
            <div class="col">
             
                    <input type="text" :id="value.faxId" v-if="!readonly" :name="value.faxId" placeholder="Numero di fax" v-model="value.faxNumber" class="form-control" >
               
                <span v-if="readonly">
                    {{value.faxNumber}}
                </span>
              
            </div>
        </div>
           
          
        </div>

       

</template>
<script>

export default {
        name: 'fax',
       
        props: {
            readonly: {
                type: Boolean,
                required: false,
                default:() => false
            },
             last: {
                type: Boolean,
                required: true,
                default:() => false
            },
              first: {
                type: Boolean,
                required: false,
                default:() => false
            },
            value: {
                type: Object,
                required: false,
                
            },
            index: {
                type: Number,
                required: false,
                default:()=>0
            }
        },
      
        components: {
           
        },
        data() {
            return {
                hover:false
            }
        },
        methods: {
            
         
            upddateLabel: function (label) {
                this.value.label = label;
            }
           
             , remove: function () {
                this.$emit('remove-entity', this.value)
            }

              , add: function () {
               
               
                 this.$emit('add-entity')
            }
            
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
